var _rect, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeygen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_11374)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_11374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0641 25.5727C12.8283 25.457 12.7015 25.6068 12.7015 25.9705C12.7015 26.3343 12.7153 27.6417 12.9974 28.1978C13.2577 28.7111 13.6731 29.1285 14.184 29.3901C14.6279 29.6173 15.1767 29.6709 16.0897 29.6835C18.6042 29.5708 20.8047 28.2453 22.1259 26.2752C22.2431 26.1002 22.1141 25.8718 21.9042 25.8718H15.9018C15.0684 25.8718 13.8164 25.9419 13.0641 25.5727ZM12.0302 14.3242C12.0302 13.952 11.5405 13.8187 11.3553 14.141C10.577 15.4956 9.79861 16.8502 9.02013 18.2047C7.12248 21.5066 7.77617 25.9344 11.4343 28.4258C11.8868 28.7341 12.2488 28.244 12.161 27.8601C11.9742 27.0755 12.0302 26.2043 12.0302 25.3989V14.3242ZM26.5953 17.7844C26.6134 18.0474 26.8059 18.0829 27.1194 17.901C27.433 17.7191 28.5529 17.0534 28.8912 16.5299C29.2035 16.0468 29.3556 15.4766 29.3256 14.9013C29.2995 14.4013 29.0712 13.897 28.6256 13.0962C27.2712 10.9645 25.0285 9.71241 22.6699 9.54795C22.4604 9.53334 22.3281 9.75979 22.4331 9.94245L25.4343 15.1656C25.8509 15.8908 26.5374 16.9452 26.5953 17.7844ZM17.417 24.3081C17.0962 24.4942 17.2261 24.987 17.5965 24.987C18.5711 24.987 20.0997 24.987 22.2666 24.9871C26.0614 24.9875 29.5509 22.2047 29.8692 17.7758C29.9086 17.228 29.3052 17.158 29.0183 17.4263C28.4354 17.9811 27.6565 18.368 26.9623 18.7707L17.417 24.3081ZM13.299 9.97478C13.5166 9.82748 13.4509 9.64222 13.1374 9.46037C12.8239 9.27851 11.6901 8.63682 11.0698 8.6042C10.4972 8.57405 9.92977 8.72679 9.44887 9.04055C9.03101 9.31325 8.71045 9.76398 8.24305 10.5522C7.08293 12.7966 7.1251 15.3741 8.16264 17.5088C8.25478 17.6984 8.51614 17.7003 8.62113 17.5176L11.6223 12.2945C12.039 11.5693 12.6046 10.4448 13.299 9.97478ZM23.5112 14.6995C23.832 14.8856 24.1917 14.5261 24.0065 14.2038C23.5192 13.3558 22.7549 12.0257 21.6716 10.14C19.7745 6.83775 15.6313 5.19268 11.6549 7.1301C11.163 7.36975 11.4044 7.92984 11.7791 8.04533C12.5488 8.27517 13.2717 8.75947 13.9658 9.16217L23.5112 14.6995Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.64185 5.14539H31.7078V30.9723H5.64185V5.14539Z",
    fill: "#28A7E5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_126_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0615 46.5777C52.6818 46.5777 63.7232 35.4835 63.7232 21.7981C63.7232 8.11271 52.6818 -2.98151 39.0615 -2.98151C25.4413 -2.98151 14.3999 8.11271 14.3999 21.7981C14.3999 35.4835 25.4413 46.5777 39.0615 46.5777Z",
    fill: "#9F59FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_126_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6387 22.2702C44.6186 22.2702 49.4663 17.3993 49.4663 11.3908C49.4663 5.38219 44.6186 0.511292 38.6387 0.511292C32.6587 0.511292 27.811 5.38219 27.811 11.3908C27.811 17.3993 32.6587 22.2702 38.6387 22.2702Z",
    fill: "#FF2FC5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_126_11374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.119986 45.8942C7.61783 45.8942 13.696 39.7869 13.696 32.2532C13.696 24.7195 7.61783 18.6122 0.119986 18.6122C-7.37785 18.6122 -13.4561 24.7195 -13.4561 32.2532C-13.4561 39.7869 -7.37785 45.8942 0.119986 45.8942Z",
    fill: "#42C7F1"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 24.2658V14.3239C12.0312 13.9517 11.5409 13.8197 11.3556 14.142L8.86401 18.4783L12.0312 24.2658Z",
    fill: "url(#paint0_linear_126_11374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9977 19.332L17.4287 24.303C17.1079 24.4891 17.2393 24.9818 17.6097 24.9818H22.593L25.9977 19.332Z",
    fill: "url(#paint1_linear_126_11374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9368 9.72015L23.5057 14.6911C23.8265 14.8772 24.1855 14.5165 24.0002 14.1942L21.5086 9.85794L14.9368 9.72015Z",
    fill: "url(#paint2_linear_126_11374)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_126_11374",
    x: -448.614,
    y: -465.996,
    width: 975.351,
    height: 975.587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 231.507,
    result: "effect1_foregroundBlur_126_11374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_126_11374",
    x: -132.397,
    y: -159.697,
    width: 342.071,
    height: 342.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80.104,
    result: "effect1_foregroundBlur_126_11374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_126_11374",
    x: -205.204,
    y: -173.136,
    width: 410.648,
    height: 410.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 95.874,
    result: "effect1_foregroundBlur_126_11374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_11374",
    x1: 10.2709,
    y1: 12.9664,
    x2: 10.2709,
    y2: 24.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126_11374",
    x1: 17.1388,
    y1: 26.5136,
    x2: 26.8812,
    y2: 20.9155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_126_11374",
    x1: 25.5559,
    y1: 13.8381,
    x2: 15.8135,
    y2: 8.24009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_11374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeygen);
export default __webpack_public_path__ + "static/media/Logo_Heygen.12a2f31c4bb07a4d17d1e2714b8db921.svg";
export { ForwardRef as ReactComponent };